/* eslint-disable react/no-danger */

import React from 'react';
import { Message } from 'semantic-ui-react';
import { shape } from 'prop-types';

const Text = ({ body }) => (body ? (
  <div dangerouslySetInnerHTML={{ __html: body.content }} />
) : (
  <Message warning content="Error loading text" />
));

Text.propTypes = {
  body: shape().isRequired,
};

export default Text;
